






















import {Component, Prop} from 'vue-property-decorator'
import VueBase from '@/pages/vue-base'
import TinyMce from '@/components/admin/TinyMce.vue'
import Advice from '@/models/Advice'

@Component({
  components: {
    TinyMce
  }
})
export default class AddinForm extends VueBase {
  clients = [{text: '男性', value: 'man'}, {text: '女性', value: 'woman'}]
  advisors = [{text: '鎌田さん', value: 'kamata'}, {text: '滝本さん', value: 'takimoto'}]

  @Prop(Object) readonly post!: Advice
}
